<template>
  <div
    :class="[
      $style.wrapper,
      $style[`variant-${variant}`]
    ]"
  >
    <b-container class="d-flex flex-column align-items-center text-center py-4">
      <font-awesome-icon
        v-if="icon"
        :icon="icon"
        size="4x"
        class="mb-3"
      />
      <b-img
        v-if="image"
        :src="require(`@/assets/images/icons/${image}`)"
        :class="$style.image"
      />
      <span
        :class="[
          $style.title,
          titleColor && $style[`title-color-${titleColor}`]
        ]"
      >
        {{ title }}
      </span>
      {{ description }}
      <font-awesome-icon
        v-if="hasArrow"
        icon="chevron-down"
        class="mt-3"
        size="2x"
      />
      <div>
        <slot />
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'InfoBlock',
  props: {
    title: {
      type: String,
      default: '',
    },
    titleColor: {
      type: String,
      default: 'orange',
    },
    description: {
      type: String,
      default: '',
    },
    icon: {
      type: [Array, String],
      default: '',
    },
    image: {
      type: String,
      default: '',
    },
    hasArrow: {
      type: Boolean,
      required: false,
      default: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'darkBlue',
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .wrapper {
    color: $color-white;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    &.variant-darkBlue {
      background-image: url('@/assets/images/modal_bg.jpg');
    }
    &.variant-red {
      background-image: url('@/assets/images/modal_bg_red.jpg');
    }
    .title {
      color: $color-tomato;
      font-size: $font-size-xlarge;
      text-transform: uppercase;
      font-weight: 600;
      &.title-color-blue {
        color: $color-bleu-de-france;
      }
    }
    .image {
      max-width: 100px;
      max-height: 100px;
      margin-bottom: 1rem;
    }
  }
</style>
